import {
  Check, ChartColumn, Clock, Code, Coffee, Globe, Heart, House, Leaf, Lock, MapPin, Plane, ShieldCheck, Sparkles, Star, Users, Wrench, Zap,
  type LucideIcon,
} from "lucide-react";
import type { IconName } from "../../content/industry";

/**
 * Iconos de la librería Lucide (lucide.dev, licencia ISC). Para usar uno nuevo: agrega su nombre a IconName en
 * content/industry.ts e impórtalo aquí desde "lucide-react". No uses emojis: se ven distintos en cada sistema.
 */
export const icons: Record<IconName, LucideIcon> = {
  shield: ShieldCheck,
  clock: Clock,
  spark: Sparkles,
  leaf: Leaf,
  chart: ChartColumn,
  users: Users,
  tool: Wrench,
  globe: Globe,
  heart: Heart,
  check: Check,
  map: MapPin,
  cup: Coffee,
  code: Code,
  lock: Lock,
  bolt: Zap,
  home: House,
  star: Star,
  plane: Plane,
};

export function Icon({ name, size = 24, className = "ix-icon" }: { name: IconName; size?: number; className?: string }) {
  const Glyph = icons[name];
  return <Glyph className={className} size={size} strokeWidth={1.75} aria-hidden="true" focusable="false" />;
}
